module.exports = __webpack_public_path__ + "static/media/reason-react-red.f4982491.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/reason-react-red.svg
// module id = 37
// module chunks = 0